import {Component} from 'react';

import Airport from './Airport';

class Wrapper extends Component {

    constructor(props) {
        super(props);

        this.handleToggle = this.handleToggle.bind(this);

        this.state = {
            closed: true,
        };
    }

    render() {
        return (
            <Airport
                {...this.props}
                {...this.state}
                onToggle={this.handleToggle}
            />
        );
    }

    handleToggle(event) {
        event.preventDefault();
        event.stopPropagation();

        return this.setState(({closed}) => ({closed: !closed}));
    }

}

export default Wrapper;
